<template>
  <v-card flat height="calc(100vh - 106px)" class="overflow-y">
    <v-container>
      <v-row>
        <v-col align="center"><v-img src="@/assets/Square_combinationmark_black.png" width="200"/></v-col>
      </v-row>
      <template v-if="!square">
        <v-row class="my-4">
          <v-col align="center"><v-btn color="primary" @click="requestAuthorize" :loading="loading">Connect</v-btn></v-col>
        </v-row>
        <v-row>
          <v-col/>
          <v-col cols="12" sm="10" align="center">
            To connect, you will be taken to Square and asked to Sign In if you are not already signed in.
            You will then have to confirm you want to make the connection before being returned to PŪRTRAK to
            continue setting up the integration.
          </v-col>
          <v-col/>
        </v-row>
      </template>
      <template v-else>
        <v-row>
          <v-col align="center">
            PŪRTRAK is connected to Square.
          </v-col>
        </v-row>
        <v-row class="mt-10">
          <v-col align="center"><v-btn color="primary" outlined @click="confirmDisconnect=true">Disconnect</v-btn></v-col>
        </v-row>
      </template>
    </v-container>

    <v-dialog v-model="confirmDisconnect" persistent max-width="350">
      <v-card>
        <v-card-title>Disconnect</v-card-title>
        <v-divider/>
        <v-card-text class="pt-4">
          Are you sure you want to disconnect from Square?
        </v-card-text>
        <v-divider/>
        <v-card-actions class="pr-6">
          <v-spacer></v-spacer>
          <v-btn color="primary" plain @click="disconnect" :loading="loading">Disconnect</v-btn>
          <v-btn color="primary" @click="confirmDisconnect=false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
export default {
  name: 'AppsSquareConnection',
  props: {
    square: {type:Object, required:false}
  },
  data() {
    return {
      loading: false,
      confirmDisconnect: false,
    }
  },
  methods: {
    async requestAuthorize() {
      this.loading = true;
      localStorage.setItem('oauthState', Date.now());
      localStorage.setItem('oauthCompanyId', this.$store.state.companyId);
      const results = await this.$apiCall(`query AppsSquareConnection($state:String!) {
                                                squareAuthUri(state:$state)
                                              }`,
                                          {state:localStorage.getItem('oauthState')}, false, 'square');
      if (!results.error)
        location.href = results.data.squareAuthUri;
      else
        this.loading = false;
    },
    async disconnect() {
      this.loading = true;
      const results = await this.$apiCall(`mutation AppsSquareConnection {
                                                disconnect
                                              }`,
                                          {}, false, 'square');
      this.loading = false;
      if (!results.error) {
        this.$emit('disconnect');
        this.confirmDisconnect = false;
      }
    }
  }
}
</script>
